import { render, staticRenderFns } from "./ButtonTwoTone.vue?vue&type=template&id=18f7e8ba&scoped=true&"
import script from "./ButtonTwoTone.vue?vue&type=script&lang=js&"
export * from "./ButtonTwoTone.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTwoTone.vue?vue&type=style&index=0&id=18f7e8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7e8ba",
  null
  
)

export default component.exports